import { Component, Input } from '@angular/core';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-caricom-invoice',
  templateUrl: './caricom-invoice.component.html',
  styleUrls: ['./caricom-invoice.component.scss']
})
export class CaricomInvoiceComponent {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';

  settings: any = null;
  logoUrl: string = '';

  constructor(private _globalService: GlobalStateService) { }

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this._globalService.GetSetting().subscribe((res: any) => {
      this.settings = res.contacts?.english;
      this.logoUrl = res.logo || '';
    });
  }



  formatDate(dateString: string | null): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  formatCurrency(amount: number | null, currency: string | null = 'USD'): string {
    if (!amount || amount === 0) return '-';
    const curr = currency || 'USD';
    return `${curr} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  // Calculate total weight (placeholder - you may need to adjust based on your data structure)
  getTotalWeight(): string {
    // This would need to be calculated based on your vehicle data
    return '11,171';
  }

  // Get chassis number formatted
  getChassisNumber(invoice: Invoice): string {
    return invoice.vehicle?.vin_no || '-';
  }

  // Get stock number
  getStockNumber(invoice: Invoice): string {
    return invoice.vehicle?.car_no || '-';
  }
}
